import { render, staticRenderFns } from "./VariantPopup.vue?vue&type=template&id=2f26fd10"
import script from "./VariantPopup.vue?vue&type=script&lang=js"
export * from "./VariantPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports